/**
 * @namespace buy-fulfillment_offerings_jobs-v1
 * @description Mapping of crc error codes for buy/fulfillment_offerings_jobs/v1 using service error codes
 * @memberof ux-tread-crc-code
 *
 * @property {string} 403 - 1F78B0FA REQUEST A JOB THAT DOES NOT BELONG TO THE REQUESTING USER or  WITH MISSING UPMID OR VISITORID
 * @property {string} 406 - 6F124475 REQUEST WITH MISSING OR INVALID ACCEPT HEADER
 * @property {string} 500 - 87B38B77 WHEN SERVICE IS EXPERIENCING SYSTEM ERRORS
 * @property {string} VALIDATION_ERROR - DD2D4805 If a requested skuId doesn't exist or unavailable.
 * @property {string} REQUEST_INVALID - D748DA77 If any of request body fields is malformed, e.g. skuId should be UUID.
 * @property {string} MERCH_DATA_NOT_FOUND - 74135296 If a requested skuId doesn't exist or unavailable.
 * @property {string} LOCATIONS_NOT_FOUND - 55995B10 If a requested store location doesn't exist.
 * @property {string} FULFILLMENT_OFFERINGS_NOT_FOUND - 3FD9E715 If no fulfillment offerings found for all requested items/locations.
 * @property {string} MISSING_REQUIRED - 38422648 If a request body is missing required fields.
 * @property {string} FIELD_INVALID - E5313708 If any of request body fields is malformed, e.g. skuId should be UUID.
 * @property {string} DUPLICATE_LOCATION - 3B83CEB2 If an item has multiple locations of the same type.
 * @property {string} FORBIDDEN - 42E57C36 If a request is rejected by a downstream service, e.g. a bot attack detected.
 * @property {string} INTERNAL_SERVER_ERROR - B6E990FA Either the service caught an unhandled exception or a downstream service returned a system error
 * @property {string} VALIDATION_FAILED - F20DC66E Invalid request parameters
 */

module.exports = {
  403: '1F78B0FA',
  406: '6F124475',
  500: '87B38B77',
  VALIDATION_ERROR: 'DD2D4805',
  REQUEST_INVALID: 'D748DA77',
  MERCH_DATA_NOT_FOUND: '74135296',
  LOCATIONS_NOT_FOUND: '55995B10',
  FULFILLMENT_OFFERINGS_NOT_FOUND: '3FD9E715',
  MISSING_REQUIRED: '38422648',
  FIELD_INVALID: 'E5313708',
  DUPLICATE_LOCATION: '3B83CEB2',
  FORBIDDEN: '42E57C36',
  INTERNAL_SERVER_ERROR: 'B6E990FA',
  VALIDATION_FAILED: 'F20DC66E',
};
